import { Create, SimpleForm, usePermissions } from "react-admin";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { TeamForm } from "./TeamForm";
import { useCreateSubmit } from "../../forms";

export const TeamCreate = () => {
	// since some permissions are assigned per team, they need to be recalculated after new team gets created
	const { refetch } = usePermissions();

	const submit = useCreateSubmit("teams", "Team created", undefined, refetch);

	return (
		<Create title="Create team">
			<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
				<TeamForm />
			</SimpleForm>
		</Create>
	);
};
